import { localStorage } from '@sorare/core/src/lib/storage/localStorage';
import { sessionStorage } from '@sorare/core/src/lib/storage/sessionStorage';

import {
  queryParamsToLocalStorageKeys,
  queryParamsToSessionStorageKeys,
} from './storage';

const falsyRegex = /undefined|null|false|0/;

// eslint-disable-next-line no-restricted-properties
const searchParams = new URLSearchParams(window.location.search);

const LOCAL_STORAGE_KEYS = Object.keys(
  queryParamsToLocalStorageKeys
) as (keyof typeof queryParamsToLocalStorageKeys)[];
// if any UTM params are present, clear former ones from local storage first to avoid merging them together
if (LOCAL_STORAGE_KEYS.some(key => searchParams.get(key))) {
  LOCAL_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}

Object.entries(queryParamsToLocalStorageKeys).forEach(([qsKey, lskey]) => {
  const value = searchParams.get(qsKey);
  if (value && !falsyRegex.test(value)) {
    localStorage.setItem(lskey, value);
  }
});
Object.entries(queryParamsToSessionStorageKeys).forEach(([qsKey, sskey]) => {
  const value = searchParams.get(qsKey);
  if (value && !falsyRegex.test(value)) {
    sessionStorage.setItem(sskey, value);
  }
});
